<template>
  <div>
    <div v-if="true">
      <base-subheader>
        <slot name="header"></slot>
      </base-subheader>
      <slot></slot>
    </div>
    <base-card v-else class="ma-1 my-5">
      <!-- <base-subheader></base-subheader> -->
      <h3 class="text-h6 text-uppercase black white--text lighten-2 px-4 mt-10">
        <slot name="title"></slot>
      </h3>
      <v-card-text>
        <slot></slot>
      </v-card-text>
    </base-card>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
